import script from "./form-card-auto.vue?vue&type=script&setup=true&lang=js"
export * from "./form-card-auto.vue?vue&type=script&setup=true&lang=js"

import "./form-card-auto.vue?vue&type=style&index=0&id=7b4c1a7a&lang=less&scoped=true"
import "./form-card-auto.vue?vue&type=style&index=1&id=7b4c1a7a&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b4c1a7a"]])

export default __exports__